module.exports = __webpack_public_path__ + "static/media/statistics-not-enrolled.97f7b5da.svg";